import { render, staticRenderFns } from "./GoalsDiagram.vue?vue&type=template&id=4f7d95e2&scoped=true"
import script from "./GoalsDiagram.vue?vue&type=script&lang=ts"
export * from "./GoalsDiagram.vue?vue&type=script&lang=ts"
import style0 from "./GoalsDiagram.vue?vue&type=style&index=0&id=4f7d95e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7d95e2",
  null
  
)

export default component.exports